module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img52.5a4f23cd.jpg";